export default __webpack_public_path__ + "static/media/yubyn.png.webp";